import { render, staticRenderFns } from "./LawDetail.vue?vue&type=template&id=4643993d"
import script from "./LawDetail.vue?vue&type=script&lang=js"
export * from "./LawDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports